module.exports = __webpack_public_path__ + "static/media/home_healthcare_document.25369515.png";